// A beaver, modelled facing +X: a stout brown body, a blunt head with big
// orange teeth and a flat paddle tail. Ported 1:1 from age-of-mcp's classic
// beaver.ts, restoring its body/head/tail composition + stubby-leg loop.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [
    { geometry: new THREE.IcosahedronGeometry(0.038, 0), color: "#5e4128",
      position: [0, 0.04, 0], scale: [1.5, 1.1, 1] },               // body
    { geometry: new THREE.IcosahedronGeometry(0.024, 0), color: "#6a4a2e",
      position: [0.05, 0.052, 0] },                                  // head
    { geometry: new THREE.BoxGeometry(0.008, 0.008, 0.012), color: "#e0a020",
      position: [0.072, 0.04, 0] },                                  // incisors
    { geometry: new THREE.IcosahedronGeometry(0.007, 0), color: "#4a3220",
      position: [0.045, 0.07, 0.016] },                            // ear
    { geometry: new THREE.IcosahedronGeometry(0.007, 0), color: "#4a3220",
      position: [0.045, 0.07, -0.016] },
    // Flat scaly paddle tail trailing behind, low to the ground.
    { geometry: new THREE.BoxGeometry(0.06, 0.008, 0.04), color: "#3a2a1c",
      position: [-0.07, 0.018, 0] },
  ];
  // Stubby legs.
  for (const [x, z] of [[0.025, 0.028], [0.025, -0.028], [-0.025, 0.028], [-0.025, -0.028]]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.006, 0.006, 0.04, 4),
      color: "#4a3220", position: [x!, 0.02, z!] });
  }
  return parts;
}

export const beaver = defineModel({
  id: "beaver",
  batchId: "standard",
  name: "Beaver",
  tags: ["creature","beaver","low-poly","age-of-mcp","classic","water"],
  summary: "Low-poly beaver.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.09,
  parts: () => partsFor(),
  animations: [],
});
